import { Tag, Flex, Text } from "@chakra-ui/react";
import { Tooltip } from "antd";
import { UnidadePaginateResponse } from "core/features/unidades/typings/unidade";
import { BsFillPersonFill } from "react-icons/bs";
import { IoMdMail } from "react-icons/io";
import { MdLocalPhone } from "react-icons/md";
import colors from "core/resources/theme/colors";
import { formatPhone } from "infra/helpers/number";
import TagStatus from "./TagStatus";
import { GoAlert } from "react-icons/go";
import { tagSetorJuridicoString } from "features/conta/typings";

function useListagemUnidadeColumns() {
  return [
    {
      title: "Unidade",
      width: "250px",
      render: (item: any) => {
        if (!item.blocoQuadra) {
          return item.numero;
        }

        return (
          <Flex gap={2} alignItems="center">
            <Flex mt="2px" fontSize="12px" fontWeight="bold">
              <Tag>{item.blocoQuadra.nome}</Tag>
            </Flex>

            <Flex>{item.numero}</Flex>
          </Flex>
        );
      },
    },
    {
      title: "Proprietário(a)",
      width: "300px",
      render: (original: UnidadePaginateResponse) => (
        <Tooltip
          overlayInnerStyle={{ width: "max-content" }}
          placement="bottom"
          color="#eff4ff"
          title={
            <Flex flexDirection="column" color="black" p={2}>
              <Flex align="center" gap={2}>
                <BsFillPersonFill color={colors.primaryLight} />
                {original.pessoa?.nome}
              </Flex>
              {original.pessoa?.celular ? (
                <Flex align="center" gap={2}>
                  <MdLocalPhone color={colors.primaryLight} />
                  {formatPhone(original.pessoa?.celular)}
                </Flex>
              ) : null}

              <Flex align="center" gap={2}>
                <IoMdMail color={colors.primaryLight} />
                {original.pessoa?.email}
              </Flex>
              <Text></Text>
            </Flex>
          }
        >
          <Flex w="fit-content">
            {original.pessoa?.nome ?? (
              <Tag variant="outline" colorScheme="orange">
                Sem proprietário(a)
              </Tag>
            )}
          </Flex>
        </Tooltip>
      ),
    },
    {
      title: "",
      render: (original: UnidadePaginateResponse) => (
        <Flex gap={4}>
          {original.inadimplencia ? (
            <TagStatus
              colorScheme="orange"
              title="Inadimplente"
              icon={<GoAlert />}
            />
          ) : null}
          {original.juridico ? (
            <TagStatus
              colorScheme="red"
              title={tagSetorJuridicoString}
              icon={<GoAlert />}
            />
          ) : null}
          {original.ajuizada ? (
            <TagStatus colorScheme="gray" title={"Ajuizada"} />
          ) : null}
          {original.unificada ? (
            <TagStatus colorScheme="blue" title={"Unificada"} />
          ) : null}
          {original.acordoParceladoEmAberto ? (
            <TagStatus
              colorScheme="gray"
              title={"Acordo parcelado em aberto"}
            />
          ) : null}
        </Flex>
      ),
    },
  ];
}

export default useListagemUnidadeColumns;
